/** @jsx jsx */
import { useEffect, useState } from 'react';
import moment from 'moment';
import { useTimestamp } from './hooks';
import { jsx } from 'theme-ui';

export default function TimeReport(props) {
	const TIME_WHEN_VOTES_WILL_BE_COUNTED = 1593201600;
	const timestamp = useTimestamp(props.mainnetProvider);
	const timeLeft2 = TIME_WHEN_VOTES_WILL_BE_COUNTED - timestamp;
	var day = moment.unix(TIME_WHEN_VOTES_WILL_BE_COUNTED).format('YYYY-MM-DD HH:mm');
	const calculateTimeLeft = () => {
		const difference = +new Date(day) - +new Date();
		let timeLeft = {};

		if (difference > 0) {
			timeLeft = {
				days: Math.floor(difference / (1000 * 60 * 60 * 24)),
				hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
				minutes: Math.floor((difference / 1000 / 60) % 60),
				seconds: Math.floor((difference / 1000) % 60)
			};
		}

		return timeLeft;
	};

	const [ timeLeft, setTimeLeft ] = useState(calculateTimeLeft());

	useEffect(() => {
		setTimeout(() => {
			setTimeLeft(calculateTimeLeft());
		}, 1000);
	});

	const timerComponents = [];

	Object.keys(timeLeft).forEach((interval) => {
		if (!timeLeft[interval]) {
			return;
		}

		timerComponents.push(
			<span>
				{timeLeft[interval]} {interval}{' '}
			</span>
		);
	});

	return (
		<span>
			<span className="loading dots3" sx={{ display: 'block', mb: 's' }} />Vote ends in{' '}
			{timerComponents.length ? timerComponents : <span>Time's up!</span>}
			<span className="loading dots3" sx={{ display: 'block', mt: 's' }} />
		</span>
	);
}
